import * as React from 'react';
import { Column } from "react-table";
import { Button } from '@mantine/core';
import { Link } from "react-router-dom";
import Table from "../../components/table/Table";
import { CLIENT_ROUTE, API_ROUTE, CLIENT_TITLE } from "./constants";
import { IconPlus } from "@tabler/icons-react";
import TableIndicator from "../../components/common/TableStatus";
import dayjs from "dayjs";
import Page from "../../components/layout/Page";
import { useListPage } from "../../hooks";
import RowActions from "../../components/table/RowActions";

interface IUserRecord {
    _id: string;
    email: string;
    isActive: boolean;
    roleName: number;
    name: string;
    actions: unknown;
    createdAt: string;
}

const UserList = () => {

    const { records, deleteRecord, handleInteraction, paginationState } = useListPage({
        apiRoute: API_ROUTE,
        clientRoute: CLIENT_ROUTE
    })

    const columns: Column<IUserRecord>[] =  [
        {
            Header: 'И-мэйл',
            accessor: 'email',
        },
        {
            Header: 'Нэр',
            accessor: 'name'
        },
        {
            Header: 'Эрх',
            accessor: 'roleName',
        },
        {
            Header: 'Төлөв',
            accessor: 'isActive',
            Cell: ({ value }) => {
                return <TableIndicator active={value}/>;
            },
            width: 1
        },
        {
            Header: 'Үүссэн огноо',
            accessor: 'createdAt',
            Cell: ({ value }) => {
                return (
                    <div>
                        {dayjs(value).format('YYYY.MM.DD HH:mm')}
                    </div>
                );
            }
        },
        {
            Header: '',
            accessor: 'actions',
            Cell: (table) => {
                return (
                    <RowActions id={table.row.original._id} clientRoute={CLIENT_ROUTE} deleteRecord={deleteRecord} />
                )
            }
        },
    ];

    return (
        <Page>
            <Page.Header title={CLIENT_TITLE}>
                <Button
                    component={Link}
                    to={`${CLIENT_ROUTE}/new`}
                    leftIcon={<IconPlus size={18}/>}
                    color={'color-secondary'}
                >
                    Үүсгэх
                </Button>
            </Page.Header>
            <Page.Body>
                <Table
                    searchable
                    columns={columns}
                    data={records}
                    totalPages={paginationState.totalPage}
                    onInteraction={handleInteraction}
                />
            </Page.Body>
        </Page>
    )
};

export default UserList;